import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

interface FaqItemProps {
  question: string;
  answer: string;
  index: number;
}

export const FaqItem = ({ question, answer, index }: FaqItemProps) => {
  return (
    <AccordionItem
      value={`item-${index}`}
      className="group bg-gray-800 rounded-lg border border-gray-700 shadow-sm hover:shadow-md hover:border-gray-600 transition-all duration-300"
    >
      <AccordionTrigger 
        className="text-base font-medium hover:no-underline px-6 py-4 md:px-4 md:py-3 text-left text-white data-[state=open]:text-blue-400 group-hover:text-blue-300 transition-all duration-300 ease-in-out touch-manipulation"
      >
        {question}
      </AccordionTrigger>
      <AccordionContent 
        className="text-sm text-gray-300 px-6 md:px-4 pb-6 pt-2 leading-relaxed transition-all duration-300 ease-in-out data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      >
        {answer}
      </AccordionContent>
    </AccordionItem>
  );
};